export const selectOwner = {
    sql: `select "id", "mnemonic", "encryptionKey" from "evolu_owner"`,
};
export const createMessageTable = {
    sql: `create table "evolu_message" ("timestamp" blob primary key, "table" blob, "row" blob, "column" blob, "value" blob)`,
};
export const createMessageTableIndex = {
    sql: `create index "index_evolu_message" on "evolu_message" ("table", "row", "column", "timestamp" desc)`,
};
export const createOwnerTable = {
    sql: `create table "evolu_owner" ("id" blob, "mnemonic" blob, "encryptionKey" blob, "timestamp" blob, "merkleTree" blob)`,
};
export const insertOwner = {
    sql: `insert into "evolu_owner" ("id", "mnemonic", "encryptionKey", "timestamp", "merkleTree") values (?, ?, ?, ?, ?)`,
};
export const selectOwnerTimestampAndMerkleTree = {
    sql: `select "timestamp", "merkleTree" from "evolu_owner"`,
};
export const selectLastTimestampForTableRowColumn = {
    sql: `select "timestamp" from "evolu_message" where "table" = ? and "row" = ? and "column" = ? order by "timestamp" desc limit ?`,
};
export const insertIntoMessagesIfNew = {
    sql: `insert into "evolu_message" ("timestamp", "table", "row", "column", "value") values (?, ?, ?, ?, ?) on conflict do nothing`,
};
export const updateOwnerTimestampAndMerkleTree = {
    sql: `update "evolu_owner" set "merkleTree" = ?, "timestamp" = ?`,
};
export const selectMessagesToSync = {
    sql: `select * from "evolu_message" where "timestamp" >= ? order by "timestamp"`,
};
